import { SubmitButton, SubmitWrapper } from "@/shared/form/button";
import Form, { FormProps } from "@/shared/form/form";

type DynamicProcessTriggerFormProps = FormProps & {
  afterSubmit?: () => void;
};

export function DynamicProcessTriggerForm({
  onFinish,
  afterSubmit,
  ...props
}: DynamicProcessTriggerFormProps) {
  return (
    <Form
      onFinish={(values) => {
        onFinish?.(values);
        afterSubmit?.();
      }}
      {...props}
    >
      <SubmitWrapper>
        <SubmitButton />
      </SubmitWrapper>
    </Form>
  );
}
